import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { Organization } from 'src/app/modules/organization-admin/models/organization';
import { OrganizationAdminService } from 'src/app/modules/organization-admin/services/organization-admin.service';
import { Users } from 'src/app/modules/users/models/users';
import { UsersService } from 'src/app/modules/users/services/users.service';
import { CURRENT_PAGE, ITEMS_PER_PAGE, PAGE_LENGTH, PAGE_SIZE_OPTIONS } from 'src/app/shared/constants/pagination.constants';
import { ScreenshotService } from '../../services/screenshot.service';
import { Screenshot } from '../../models/screenshot';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'app-screenshot-details',
  templateUrl: './screenshot-details.component.html',
  styleUrls: ['./screenshot-details.component.css']
})
export class ScreenshotDetailsComponent implements OnInit,AfterViewInit {

  @ViewChild('paginator', {static: true}) paginator: MatPaginator;
  
  public PAGE_SIZE_OPTIONS_DATA:number[] = PAGE_SIZE_OPTIONS;

  public page_length:number = PAGE_LENGTH;

  public items_per_page:number = ITEMS_PER_PAGE;

  public current_page:number = CURRENT_PAGE;

  public screenshotsDataSource:any;

  public hasRole:string = this.authservice.hasRole();
  public orgId:string = this.authservice.getOrgId();
  public organizations:Organization[];
  public users:Users;

  public fromMaxDate:Date;
  public fromMinDate:Date;
  public toMaxDate:Date;
  public toMinDate:Date;

  public isShowOrganization:boolean = false;

  public AdvancedSearchForm:FormGroup;

  public searchUserNameCtrl = new FormControl('',Validators.required);


  constructor( 
    private authservice:AuthenticationService,
    private organizationService:OrganizationAdminService,
    private userService:UsersService,
    private screenshotService:ScreenshotService,
    private fb:FormBuilder,
  ) { }

  ngOnInit(): void {
    // this.setMinAndMaxValues();

    this.createAdvancedSearchForm();

    if(this.hasRole == '1'){
      this.isShowOrganization =true;
        this.getOrganizations();
    }

    this.searchUserName();

    this.getUsers(this.orgId);
  }

  ngAfterViewInit(){
    if(this.screenshotsDataSource != undefined){
      this.screenshotsDataSource.paginator = this.paginator;
    }
  }

  createAdvancedSearchForm():void{
    this.AdvancedSearchForm = this.fb.group({
      org_id: [this.orgId],
      user_id:['',[Validators.required]],
      from_date: [''],
      to_date: [''],
    });
  }

  get AdvancedSearchFormValidate(){
    return this.AdvancedSearchForm.controls;
  }

  AdvancedSearchFormSubmit():void{

    if(this.AdvancedSearchForm.invalid){
      return;
    }

    if(this.AdvancedSearchForm.value.from_date != "")
      this.AdvancedSearchForm.patchValue({
        from_date: moment(this.AdvancedSearchForm.value.from_date).format("YYYY-MM-DD"),
      });

    if(this.AdvancedSearchForm.value.to_date != "")
      this.AdvancedSearchForm.patchValue({
        to_date: moment(this.AdvancedSearchForm.value.to_date).format("YYYY-MM-DD"),
      });

    console.log(this.AdvancedSearchForm.value);

    let filterParams = this.addFilterParameters();

    filterParams["user_id"] = this.AdvancedSearchForm.value.user_id;
    filterParams["from_date"] = this.AdvancedSearchForm.value.from_date;
    filterParams["to_date"] = this.AdvancedSearchForm.value.to_date;

    this.getScreenshots(filterParams);
  }

  getScreenshots(filterParams){

    this.screenshotService.getScreenshots(filterParams).subscribe(
      (res:any)=>{
        this.page_length = res.headers.get('X-Pagination-Total-Count');
        this.current_page = res.headers.get('X-Pagination-current-page');
        this.items_per_page = res.headers.get('X-Pagination-Per-Page');
        this.screenshotsDataSource = new MatTableDataSource<any>(res.body);
        
        // this.ngAfterViewInit();
      }
    )
  }

  organizationChange(event){
    this.getUsers(event.source.value);
  }

  getOrganizations():void{
    this.organizationService.getOrganizations().subscribe(
      (res:any)=>{
        this.organizations = res.body;
      }
    );
  }

  getUsers(orgId:string = undefined ):void{

    let filterParams = {};

    filterParams["sort"] = "-id";

    if(orgId != undefined){
      filterParams['filter[org_id]'] = orgId;
    }

    let searchParams = this.searchUserNameCtrl.value; 

    if( searchParams != '' && searchParams.length >= 3){
      filterParams['filter[name][like]'] = searchParams.trim();
    }

    this.userService.getUsersList(filterParams).subscribe(
        (res:any)=>{
          this.users = res.body;
          // console.log(`user details :: `,this.users);
        }
      );
  }

  addFilterParameters():Object{
    let filterParams = {};
    // filterParams['filter[org_id]'] = this.orgId;
    filterParams['page']= this.current_page;
    filterParams["per-page"]= this.items_per_page;
    filterParams["sort"] = "-id";
    return filterParams;
  }

  handlePage(e?: any):void {
    if(e){
      this.current_page = e.pageIndex+1;
      this.items_per_page = e.pageSize;
      this.page_length = e.length;
    }
    this.AdvancedSearchFormSubmit();
  }

  setMinAndMaxValues():void{
    this.fromMinDate = new Date();
    this.toMinDate = new  Date();
  }

   /*** TO SET TO_DATE MINIMUN VALUE, WHICH IS NOTHING BUT CURRENT VALUE OF FROM_DATE ***/
   onFromDateChange(event):void{
    this.toMinDate = event.target.value;
  }

  /*** TO SET FROM_DATE MAXIMUM VALUE, WHICH IS NOTHING BUT CURRENT VALUE OF TO_DATE ***/
  onToDateChange(event):void{
    this.fromMaxDate = event.target.value;
  }

  refreshData(){
    this.AdvancedSearchFormSubmit();
  }

  searchUserName(){
      this.searchUserNameCtrl.valueChanges
      .pipe(
        delay(300),
      )
      .subscribe(val=> {

        this.AdvancedSearchForm.patchValue({
          'user_id': (this.searchUserNameCtrl.value != null )?this.searchUserNameCtrl.value.id:''
        });

        this.getUsers(this.AdvancedSearchForm.value.org_id)

      });
  }

  displaySearchUserName(users:Users) {
    if (users) { return users.name; }
  }


}
